module.exports = __webpack_public_path__ + "img/scoreStep_right.4afa9864.svg";